import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ progress }) => (
  <div className="relative">
    <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-progressbar bg-opacity-25">
      <div
        style={{ width: `${progress}%` }}
        className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-progressbar"
      />
    </div>
  </div>
);

ProgressBar.propTypes = {
  progress: PropTypes.number,
};

ProgressBar.defaultProps = {
  progress: 0,
};

export default ProgressBar;
